<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Edit</span>
        <b-button size="sm" variant="danger float-right" @click="delete_item">Delete</b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>

        <b-form @submit.stop.prevent="edit_item">
          <b-form-group label="Name:" invalid-feedback="Must be greater then 4 character" description="Name of the item">
            <b-form-input v-model="item.name" required placeholder="Enter name" :state="validate_state('name')"></b-form-input>
          </b-form-group>

          <!-- TODO can't edit variables -->

          <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
        </b-form>

      </div>
    </b-card>
  </b-container>
</template>

<script>
import { db } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"

export default {
  metaInfo: {title: 'Recipient edit'},
  mixins: [ItemMixin],
  firestore: function () {
    return {
      item: db.collection('sequence').doc(this.$route.params.id).collection(this.collection).doc(this.$route.params.nested_item_item)
    }
  },
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  data() {
    return {
      param: 'recipient',
      collection: 'recipient'
    }
  },
  methods: {
    navigate_to() {
      this.$router.push({name: `sequence`})
    }
  }
}
</script>

<style>

</style>
